import React from 'react'
import VIDEO from '../images/movie_database_danish_copy.mp4';
import { AppVideo, HeroInner, HeroLeft, HeroSection } from './Cases.syled'
import NavBar from '../NavBar';
import { MainTitle, Paragraf } from '../Styled';
import CTAUp from '../blocks/CTAUp';
import APPMOCKUPS from '../images/cases-img.png';
import CaseSlider from '../blocks/CaseSlider';
import Footer from '../blocks/Footer';

const Cases = () => {
    return (
        <div>
            <HeroSection>
                <NavBar />
                <HeroInner>
                    <HeroLeft>
                        <MainTitle>
                            Du Er Helten. Vi Hjælper Dig På Vej
                        </MainTitle>
                        <Paragraf>
                            Som et bureau indenfor Appudvikling ved vi hvad du har brug for, for at komme et stort skridt nærmere på success indenfor din branche.
                        </Paragraf>
                    </HeroLeft>
                    <div>
                        <AppVideo src={VIDEO} frameBorder="0" title='Film database App' autoPlay loop />
                    </div>
                </HeroInner>
            </HeroSection>
            <CTAUp
                title='Apps under udvikling'
                body='Vi har i øjeblikket projekter i drift, som vil kunne ses på denne side så snart de er oppe og køre. Du kan læse mere om hvordan vi udvikler Apps under Appudvikling.'
                btn='Læs mere'
                photo={APPMOCKUPS}
                alt='Placeholder'
                to='/appudvikling'
            />
            <section>
                <CaseSlider />
            </section>
            <Footer />
        </div>
    )
}

export default Cases